<template>
    <div class="modal-container standard" v-if="showModal">
        <div>
            <div class="header-rainbow"></div>
            <button v-on:click="close()" class="close">
                <Icon icon="close"></Icon>
            </button>
            <PromptHeader></PromptHeader>
            <main>
                <h1>{{ title }}</h1>
                <span>{{ message }}</span>
                <button v-on:click="close()" class="btn-dark cancel">{{ $t('buttons.cancel') }}</button>
                <button v-on:click="accept()" class="btn-dark save">{{ acceptbutton }}</button>
            </main>
        </div>
    </div>
</template>

<script>
    import PromptHeader from "./PromptHeader";
    import Icon from "./Icon";

    export default {
        name: 'Prompt',
        components: {Icon, PromptHeader},
        props: ['title', 'message', 'acceptbutton'],
        data: function () {
            return {
                showModal: false,
            }
        },
        methods: {
            hide() {
                this.showModal = false;
            },
            show() {
                this.showModal = true;
                this.$store.commit('showModalCover', true);
            },
            close() {
                this.hide();
            },
            accept() {
                this.hide();
            }
        }
    }
</script>